import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import DeleteIcon from "@mui/icons-material/Delete";
import BusinessIcon from "@mui/icons-material/Business";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";

export default function CardMobile({
  item,
  openDatei,
  openDetails,
  filter,
  user,
  startDelete,
}) {
  const { t } = useTranslation();

  const shortText = (htmlText, maxLength) => {
    if (!htmlText) return "";

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, "text/html");
    const text = doc.body.textContent?.trim() || "";

    return text.length > maxLength
      ? `${text.slice(0, maxLength)}...`
      : text;
  };

  const preview = shortText(item.meldung, 80);

  return (
    <Card
      elevation={0}
      onClick={(e) => openDetails(e, item)}
      sx={{
        cursor: "pointer",
        overflow: "hidden",
        borderRadius: 3,
        border: 1,
        bgcolor: "background.paper",
        transition: ".2s",
        "&:hover": {
          borderColor: "primary.main",
        },
      }}
    >
      <CardContent
        sx={{
          p: 2,
          "&:last-child": {
            pb: 2,
          },
        }}
      >
        <Stack spacing={2}>
          {/* Header */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{
                flex: 1,
                pr: 1,
                fontSize: "1rem",
                lineHeight: 1.35,
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}
            >
              {item.betreff?.trim()}
            </Typography>

            {item?.ersteller === user?.id && (
              <IconButton
                size="small"
                color="error"
                onClick={(e) => {
                  e.stopPropagation();
                  startDelete(e, item);
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            )}
          </Stack>

          {/* Vorschau */}
          {preview && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                lineHeight: 1.55,
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {preview}
            </Typography>
          )}

          {/* Datei */}
          {item.datei && (
            <Stack direction="row" justifyContent="flex-end">
              <Button
                variant="text"
                size="small"
                startIcon={<FolderOpenIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  openDatei(e, item.datei);
                }}
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                {t("Datei öffnen")}
              </Button>
            </Stack>
          )}

          {/* Informationen */}
          <Stack spacing={1}>
            {(filter === "Aktiv" || filter === "Inaktiv") && (
              <Stack direction="row" spacing={0.75} alignItems="center">
                <EventOutlinedIcon
                  sx={{
                    fontSize: 15,
                    color: "text.secondary",
                  }}
                />

                <Typography variant="caption" color="text.secondary">
                  {item.vondat}
                  {filter !== "Aktiv" && ` – ${item.bisdat}`}
                </Typography>
              </Stack>
            )}

            <Stack direction="row" spacing={0.75} alignItems="center">
              <BusinessIcon
                sx={{
                  fontSize: 15,
                  color: "text.secondary",
                }}
              />

              <Typography variant="caption" color="text.secondary">
                {item.mandant}
              </Typography>
            </Stack>
          </Stack>

          <Divider />

          {/* Footer */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Stack
              direction="row"
              spacing={0.5}
              alignItems="center"
              minWidth={0}
            >
              {item?.erstellerText && (
                <>
                  <PersonOutlineIcon
                    sx={{
                      fontSize: 15,
                      color: "text.secondary",
                    }}
                  />

                  <Typography
                    variant="caption"
                    color="text.secondary"
                    noWrap
                  >
                    {item.erstellerText}
                  </Typography>
                </>
              )}
            </Stack>

            <Button
              size="small"
              endIcon={<ArrowForwardIcon />}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                whiteSpace: "nowrap",
              }}
            >
              {t("Mehr anzeigen")}
            </Button>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}